export default __webpack_public_path__ + "static/media/heart_regular.52eac8fa.png";